import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-dv-contract',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-dv-contract.component.html',
  styleUrl: './tekst-dv-contract.component.scss',
})
export class TekstDvContractComponent {}
